import { readOnboardingMode, type OnboardingMode } from './entry'
import { getOnboardingSteps, type OnboardingStepKey } from './steps'

type OnboardingProgressState = {
  completedStepKeys?: string[] | null
  completedAt?: string | null
}

export function clearOnboardingProgress() {
  // DB is the single source of truth for onboarding progress.
}

export function trackOnboardingStep(stepKey: OnboardingStepKey) {
  void stepKey
  // Progress tracking is persisted through Supabase-only save handlers.
}

export function markOnboardingCompleted() {
  // Completion is persisted through markOnboardingStepCompleted('review').
}

export function startOnboarding(mode?: OnboardingMode) {
  const onboardingMode = mode ?? readOnboardingMode() ?? 'guided'
  return getOnboardingSteps(onboardingMode)[0]?.path ?? '/app/onboarding/company'
}

function normalizeCompletedStepKeys(keys?: string[] | null) {
  if (!keys?.length) {
    return new Set<string>()
  }

  return new Set(keys.map((entry) => entry.trim()).filter(Boolean))
}

export function getOnboardingResumePath(mode?: OnboardingMode, progressState?: OnboardingProgressState) {
  const onboardingMode = mode ?? readOnboardingMode() ?? 'guided'
  const steps = getOnboardingSteps(onboardingMode)
  const completedStepSet = normalizeCompletedStepKeys(progressState?.completedStepKeys)

  if (progressState?.completedAt || completedStepSet.has('review')) {
    return null
  }

  const firstIncomplete = steps.find((step) => step.key !== 'review' && !completedStepSet.has(step.key))
  return firstIncomplete?.path ?? '/app/onboarding/review'
}

export function getOnboardingProgressSummary(mode?: OnboardingMode, progressState?: OnboardingProgressState) {
  const onboardingMode = mode ?? readOnboardingMode() ?? 'guided'
  const steps = getOnboardingSteps(onboardingMode)
  const totalSteps = steps.length
  const completedStepSet = normalizeCompletedStepKeys(progressState?.completedStepKeys)

  if (progressState?.completedAt || completedStepSet.has('review')) {
    return {
      stepNumber: totalSteps,
      totalSteps,
    }
  }

  if (completedStepSet.size > 0) {
    const doneCount = steps.filter((step) => step.key !== 'review' && completedStepSet.has(step.key)).length
    return {
      stepNumber: Math.min(doneCount + 1, totalSteps),
      totalSteps,
    }
  }

  return {
    stepNumber: 1,
    totalSteps,
  }
}